{
  "GENERAL": {
    "SHOWING_RESULTS": "Показані {firstIndex}-{lastIndex} з елементів {totalCount}",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Пошук",
      "EMPTY_STATE": "Результатів не знайдено"
    },
    "CLOSE": "Закрити",
    "BETA": "Beta",
    "BETA_DESCRIPTION": "This feature is in beta and may change as we improve it.",
    "ACCEPT": "Accept",
    "DISCARD": "Discard",
    "PREFERRED": "Preferred"
  },
  "CHOICE_TOGGLE": {
    "YES": "Так",
    "NO": "Ні"
  }
}
